import React from 'react';
import {withDynamicComponents} from 'higher-order-components';
import GradeAndSpecData from '../../containers/grade-and-spec-data';
import PhotoInfo from '../../containers/photo-info';
// import BodySize from '../../containers/body-size';
// import Equipment from '../../blocks/equipment';
// import MakerSetOption from '../../blocks/maker-set-option';
// import SpecComparison from '../../blocks/spec-comparison';
// import OwnerLibraryContainer from '../../containers/owner-library-container';
// import Html from '../../containers/html';
// import Wysiwyg from '../../containers/wysiwyg';

const GradeAndSpecDataBlock = props => <GradeAndSpecData {...props} />;
GradeAndSpecDataBlock.displayName = 'GradeAndSpecData';

export default withDynamicComponents({
  componentWhitelist: [
    PhotoInfo,
    // BodySize,
    // Equipment,
    // MakerSetOption,
    // SpecComparison,
    // OwnerLibraryContainer,
    // Html,
    // Wysiwyg,
  ],
  mapInputToOutput: [
    ['photoInfo', 'photoInfo'],
    // ['freeContentArea', 'freeContentArea'],
    // ['bodySize', 'bodySize'],
    // ['equipment', 'equipment'],
    // ['makerOption', 'makerOption'],
    // ['specComparison', 'specComparison'],
    // ['freeContentArea2', 'freeContentArea2'],
    // ['ownerLibraryContainer', 'ownerLibraryContainer'],
    // ['freeContentArea3', 'freeContentArea3'],
  ],
})(GradeAndSpecDataBlock);



// WEBPACK FOOTER //
// ./src/blocks/grade-and-spec-data/index.jsx